module.exports = __webpack_public_path__ + "static/img/main-bg.fc06c7aa.png";